import { useContext, useEffect, useMemo, useRef, useState } from "react"
import ActionDetailsMobile from "../../components/actions/ActionDetailsMobile"
import { MainContext } from "../../controllers/main"
import ActionDetailsDesktop from "../../components/actions/ActionDetailsDesktop"
import { ActionsContext } from "../../controllers/actions"
import { useNavigate, useParams } from "react-router-dom"
import ReactGA from "react-ga4"
import { registerPageEvent } from "../../services/utils/utils"

const ActionDetails = () => {
  const navigate = useNavigate()
  const { actionId } = useParams()
  const { isMobile, currentMission } = useContext(MainContext)
  const { actions, currentDetailedHistory, currentDate } =
    useContext(ActionsContext)

  // redirect to landing if currentMission isn't present
  useEffect(() => {
    if (!currentMission) {
      navigate("/")
    }
  }, [])

  // register google analytics event
  useEffect(() => {
    registerPageEvent("action_details")
  }, [])

  // send google analytics event
  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: "action_details" })
  }, [])

  // current action
  const action = actions.find((item) => item.id === actionId)!

  // number of times that action has been logged (TODO)
  const timesLogged = useMemo(() => {
    return currentDetailedHistory.filter(
      (item) =>
        new Date(item.createdAt).toLocaleDateString() ===
          currentDate.toLocaleDateString() && item.action.id === action.id
    ).length
  }, [currentDetailedHistory])

  // is current date (today === currentDate)
  const isCurrentDate = useMemo(() => {
    return new Date().toLocaleDateString() === currentDate.toLocaleDateString()
  }, [currentDate])

  // repeatable action info
  const [repeatableInfoOpen, setRepeatableInfoOpen] = useState<boolean>(false)

  // action logged or mission completed feedbacks
  const [logFeedbackOpen, setLogFeedbackOpen] = useState<boolean>(false)
  const [missionFeedbackOpen, setMissionFeedbackOpen] = useState<boolean>(false)

  // check if currentMission changed to show feedback
  const isFirstRender = useRef<boolean>(true)

  useEffect(() => {
    if (!isFirstRender.current && currentMission) {
      if (currentMission.satisfied) {
        setMissionFeedbackOpen(true)
      } else {
        setLogFeedbackOpen(true)
      }
    } else {
      isFirstRender.current = false
    }
  }, [currentMission])

  return isMobile ? (
    <ActionDetailsMobile
      action={action}
      timesLogged={timesLogged}
      repeatableInfoOpen={repeatableInfoOpen}
      setRepeatableInfoOpen={setRepeatableInfoOpen}
      logFeedbackOpen={logFeedbackOpen}
      missionFeedbackOpen={missionFeedbackOpen}
    />
  ) : (
    <ActionDetailsDesktop
      action={action}
      timesLogged={timesLogged}
      repeatableInfoOpen={repeatableInfoOpen}
      setRepeatableInfoOpen={setRepeatableInfoOpen}
      logFeedbackOpen={logFeedbackOpen}
      missionFeedbackOpen={missionFeedbackOpen}
    />
  )
}

export default ActionDetails
